module.exports = __webpack_public_path__ + "static/img/img-tuto03-02.e9ba9613.png";